module.exports = __webpack_public_path__ + "img/img_clients1.e366ed42.jpg";